import { override, extend } from "flarum/common/extend";
import DiscussionPage from "flarum/components/DiscussionPage";
import DiscussionHero from "flarum/components/DiscussionHero";
import ItemList from "flarum/utils/ItemList";
import Link from "flarum/components/Link";
import PostStreamState from "flarum/states/PostStreamState";
import newsElementsMaker from "../helpers/newsElementsMaker";

class RelatedTopics {
  constructor() {
    this._topics = [];
    this.app = app;
    this.loading = false;
  }

  loadTopics(discussionId) {
    this.loading = true;

    const requestUrl =
      app.forum.attribute("apiUrl") +
      "/discussions/" +
      discussionId +
      "/related";

    this.app.request({ url: requestUrl, method: "GET" }).then(({ jsonapi }) => {
      const { randomCreatorDiscussions, randomTagDiscussions } = jsonapi;
      const uniqueVals = randomTagDiscussions
        .reduce((acc, cur) => {
          const { discussions } = cur;
          const newDiscussions = discussions.map((discussion) => {
            discussion.tag = cur.tag;
            return discussion;
          });
          return [...acc, ...newDiscussions];
        }, randomCreatorDiscussions)
        .reduce((acc, cur) => {
          acc[cur.id] = cur;
          return acc;
        }, {});
      const result = [...Object.entries(uniqueVals)].map(([k, v]) => v);
      this.loading = false;
      this._topics = result;
      // m.redraw();
    });
  }

  showTopics() {
    return this._topics;
  }
}

export default function () {
  const relatedQuestionsElementsMaker = (relatedQuestions, title) => {
    if (!relatedQuestions) return null;

    return (
      <div>
        <div className="topQuestionsTitle">
          {title}
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        </div>
        {!relatedQuestions
          ? null
          : relatedQuestions.map((discussion, i) => {
              const { id, title, comment_count, slug, participant_count } =
                discussion;
              const curTag = !!discussion["tag"]
                ? discussion["tag"]
                : discussion["tags"][1]
                ? discussion["tags"][1]
                : discussion["tags"][0];
              const curRoute = `/d/${id}-${slug}`;
              // console.log(discussion);
              return (
                <div key={id} data-id={id} className="topDiscussionsMain-item">
                  {curTag ? (
                    <div style={{ "--cur-tag-color": curTag["color"] }}>
                      <i className={curTag["icon"] + " relatedQuestionsTag"} />
                      <span>{curTag["name"]}</span>
                    </div>
                  ) : null}
                  <div>
                    <Link href={curRoute} title={title}>
                      {title}
                    </Link>
                  </div>
                  <ul className="topDiscussions-paramList">
                    <li className="topDiscussions-participant_count">
                      Подписчиков {participant_count}
                    </li>
                    <li className="topDiscussions-comment_count">
                      ответов {comment_count}
                    </li>
                  </ul>
                </div>
              );
            })}
      </div>
    );
  };

  app.relatedTopicsState = new RelatedTopics();

  extend(DiscussionPage.prototype, "oninit", function (vnode) {
    const discussionId = this.attrs.id.split("-")[0];
    app.relatedTopicsState.loadTopics(discussionId);
  });

  // override(DiscussionPage.prototype, "show", function (orig, discussion) {
  //   app.history.push("discussion", discussion.title());
  //   app.setTitle(discussion.title());
  //   app.setTitleCount(0);
  //
  //   // When the API responds with a discussion, it will also include a number of
  //   // posts. Some of these posts are included because they are on the first
  //   // page of posts we want to display (determined by the `near` parameter) –
  //   // others may be included because due to other relationships introduced by
  //   // extensions. We need to distinguish the two so we don't end up displaying
  //   // the wrong posts. We do so by filtering out the posts that don't have
  //   // the 'discussion' relationship linked, then sorting and splicing.
  //   let includedPosts = [];
  //   if (discussion.payload && discussion.payload.included) {
  //     const discussionId = discussion.id();
  //
  //     includedPosts = discussion.payload.included
  //       .filter(
  //         (record) =>
  //           record.type === "posts" &&
  //           record.relationships &&
  //           record.relationships.discussion &&
  //           record.relationships.discussion.data.id === discussionId
  //       )
  //       .map((record) => app.store.getById("posts", record.id))
  //       .sort((a, b) => a.createdAt() - b.createdAt())
  //       .slice(0, 20);
  //   }
  //
  //   // Set up the post stream for this discussion, along with the first page of
  //   // posts we want to display. Tell the stream to scroll down and highlight
  //   // the specific post that was routed to.
  //   this.stream = new PostStreamState(discussion, includedPosts);
  //   this.stream.goToFirst().then(() => {
  //     this.discussion = discussion;
  //
  //     app.current.set("discussion", discussion);
  //     app.current.set("stream", this.stream);
  //   });
  // });

  override(DiscussionPage.prototype, "sidebarItems", function (curItems) {
    const { topQuestions } = app.current.data.discussion.data.attributes;
    // const topQuestions = app.relatedTopicsState.showTopics();
    // console.log(app.relatedTopicsState.showTopics());

    const items = new ItemList();
    const title = app.translator.trans(
      "tolyod-advdiscus.forum.right_side_title"
    );
    items.add(
      "advDiscusTopCategories",
      newsElementsMaker(topQuestions, title),
      -200
    );
    return items;
  });

  extend(DiscussionPage.prototype, "view", function (vnode) {
    const relatedTopics = app.relatedTopicsState.showTopics();
    // console.log(relatedTopics);
    const title = app.translator.trans(
      "tolyod-advdiscus.forum.discussion.related_questions_title"
    );
    vnode.children.push(
      m("div.container",
        m(
          "div.relatedQuestions",
          relatedQuestionsElementsMaker(relatedTopics, title)
        )
      )
    );
  });

  extend(DiscussionHero.prototype, "items", function (items) {
    const discussion = this.attrs.discussion;

    items.replace('title', <h1 className="DiscussionHero-title">{discussion.title()}</h1>);

  })
}
